/**
 * Canonical French genres — must match server `server/utils/genres.js` (FRENCH_GENRES).
 */
/** Old English query values (bookmarks / external links) → canonical French */
export const LEGACY_GENRE_QUERY_TO_FRENCH = {
  Adventure: 'Aventure',
  Drama: 'Drame',
  Comedy: 'Comédie',
  Horror: 'Horreur',
  'Science Fiction': 'Science-fiction',
  'Sci-Fi': 'Science-fiction',
  Documentary: 'Documentaire',
  Fantasy: 'Fantastique',
  Family: 'Famille',
  History: 'Histoire',
  Mystery: 'Mystère',
  Music: 'Musique',
  Romance: 'Romance',
  Thriller: 'Thriller',
  War: 'Guerre',
  Western: 'Western',
  Animation: 'Animation',
  Crime: 'Crime',
  Action: 'Action',
};

/**
 * Normalize ?genre= from URL (legacy English or French).
 */
export function normalizeGenreFromQuery(raw) {
  if (raw == null || raw === '') return '';
  const t = String(raw).trim();
  if (LEGACY_GENRE_QUERY_TO_FRENCH[t]) return LEGACY_GENRE_QUERY_TO_FRENCH[t];
  return t;
}

export const FRENCH_GENRES = [
  'Action',
  'Aventure',
  'Animation',
  'Comédie',
  'Crime',
  'Documentaire',
  'Drame',
  'Famille',
  'Fantastique',
  'Histoire',
  'Horreur',
  'Musique',
  'Mystère',
  'Romance',
  'Science-fiction',
  'Thriller',
  'Guerre',
  'Western',
];
